import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, message } from "antd";
import Clipboard from "react-clipboard.js";

// const br2nl = /<br\s*\/?>/gm;

export default ({ fontSize }) => {
  const [list, setList] = useState([]);

  const { songId } = useParams();

  useEffect(() => {
    // console.log(songId);
    const aController = new AbortController();

    (async () => {
      const params = new URLSearchParams();
      params.append("qs_idx", songId);

      const { protocol, host } = window.location;
      const inputUrl = new URL(
        `${
          process.env.NODE_ENV === "production"
            ? `${protocol}//${host}`
            : "https://ytg.kr"
        }/api/quick-praise/lyric`
      );
      inputUrl.search = params.toString();

      try {
        const listLyric = await fetch(inputUrl, {
          signal: aController.signal,
        }).then((response) => response.json());
        setList(listLyric /*.map(s => songId + s)*/);
      } catch (err) {
        setList([]);
        message.error(err.message);
      }
    })();

    return () => {
      // console.debug("starting abort: ", songId);
      aController.abort();
    };
  }, [songId]);
  return (
    <>
      {list.map((s, i) => (
        <Card
          id={`slide-${i}`}
          className={`slide`}
          key={i}
          size="small"
          style={{
            marginBottom: 10,
          }}
          bodyStyle={{
            padding: 0,
            textAlign: "center",
            fontSize: `${fontSize}vw`,
          }}
          hoverable={true}
        >
          <Clipboard
            data-clipboard-text={s}
            onSuccess={() => {
              message.success("복사되었습니다!");
            }}
            style={{
              display: "block",
              width: "100%",
              padding: 20,
              backgroundColor: "black",
              border: "none",
              color: "white",
              cursor: "pointer",
            }}
          >
            {s.split(/\r?\n/g).map((l, i2) => (
              <p key={i2} style={{ marginBottom: 0, fontHeight: 1.5 }}>
                {l}
              </p>
            ))}
          </Clipboard>
        </Card>
      ))}
    </>
  );
};
